import {
  arrayBuilderItemSubsequentPageTitleUI,
  textareaUI,
} from 'platform/forms-system/src/js/web-component-patterns';

import {
  arrayOptions,
  createNewConditionName,
  disallowWhitespaceOnly,
} from './utils';
import { trackCauseCharLimit } from '../../../utils/tracking/features/causeCharLimitTracking';

/** @returns {PageSchema} */
const causeWorsenedPage = {
  uiSchema: {
    ...arrayBuilderItemSubsequentPageTitleUI(
      ({ formData }) => createNewConditionName(formData, true),
      undefined,
      false,
    ),

    worsenedDescription: {
      ...textareaUI({
        title:
          'Briefly describe the injury, event or exposure during your military service that caused your condition to get worse.',
        updateUiSchema: (_formData, fullData, index) => ({
          'ui:title': `Briefly describe the injury, event or exposure during your military service that caused your ${createNewConditionName(
            fullData?.[arrayOptions.arrayPath]?.[index],
          )} to get worse.`,
        }),
        charcount: true,
      }),
      'ui:validations': [
        disallowWhitespaceOnly,
        // limit mirrors the schema maxLength below
        trackCauseCharLimit({
          field: 'worsenedDescription',
          cause: 'WORSENED',
          limit: 450,
        }),
      ],
    },

    worsenedEffects: {
      ...textareaUI({
        title:
          'Tell us how your condition affected you before your service and how it affects you now after your service.',
        updateUiSchema: (_formData, fullData, index) => ({
          'ui:title': `Tell us how ${createNewConditionName(
            fullData?.[arrayOptions.arrayPath]?.[index],
          )} affected you before your service, and how it affects you now after your service.`,
        }),
        charcount: true,
      }),
      'ui:validations': [
        disallowWhitespaceOnly,
        // limit mirrors the schema maxLength below
        trackCauseCharLimit({
          field: 'worsenedEffects',
          cause: 'WORSENED',
          limit: 450,
        }),
      ],
    },
  },

  schema: {
    type: 'object',
    properties: {
      worsenedDescription: {
        type: 'string',
        maxLength: 450,
      },
      worsenedEffects: {
        type: 'string',
        maxLength: 450,
      },
    },
    required: ['worsenedDescription', 'worsenedEffects'],
  },
};

export default causeWorsenedPage;
